import Vue from 'vue';
import MultiTenant from '@/presentation/components/MultiTenant/MultiTenant.vue';
import { postTenantSelectInfosApi } from 'library-components/apis/login/login';
import { E_LoginMethod } from 'library-components/apis/login/login.type';
import { applyTenantIdInterceptor } from 'library-components/config/authInterceptor';
import _ from 'lodash';
import { E_ConfirmResult } from 'library-components/utils/task';
import { getVar } from 'library-components/utils/environment';
const MultiConstructor = Vue.extend(MultiTenant);
let multiDom = null;
export class MultiTenantSelectService {
    constructor({ selector = 'body', i18n }) {
        this.pSelector = 'body';
        this.i18n = null;
        this.tenants = null;
        this._tenantId = '';
        this.beforeSelectTenant = () => { };
        this.pSelector = selector;
        this.i18n = i18n;
    }
    get TenantId() {
        return this._tenantId;
    }
    async init(params, loginType) {
        const _params = this.formatParamsByLoginType(params, loginType);
        multiDom = new MultiConstructor({
            i18n: this.i18n,
            el: document.createElement('div'),
        });
        try {
            this._tenantId = '';
            applyTenantIdInterceptor('', 'clear');
            const tenants = await this.getTenant(_params);
            if (!tenants.length) {
                return Promise.resolve(E_ConfirmResult.CONFIRM);
            }
            const defaultTenant = this.getDefaultTenant(tenants);
            if (!_.isEmpty(defaultTenant)) {
                this._tenantId = defaultTenant.tenant_id;
                applyTenantIdInterceptor(defaultTenant.tenant_id);
                return Promise.resolve(E_ConfirmResult.CONFIRM);
            }
            multiDom.tenants = tenants;
            this.beforeSelectTenant();
            document.querySelector(this.pSelector).appendChild(multiDom.$el);
            return new Promise((resolve, reject) => {
                multiDom.$on('select', (data) => {
                    this.close();
                    if (_.isEmpty(data))
                        return;
                    this._tenantId = data.tenant_id;
                    applyTenantIdInterceptor(data.tenant_id);
                    resolve(E_ConfirmResult.CONFIRM);
                });
                multiDom.$on('close', (data) => {
                    this.close();
                    resolve(E_ConfirmResult.CANCEL);
                });
            });
        }
        catch (error) {
            return Promise.reject(error);
        }
    }
    formatParamsByLoginType(params, loginType) {
        let _params = {};
        if (loginType === E_LoginMethod.password) {
            _params = {
                email: params.username,
                password: params.password,
            };
        }
        else if (loginType === E_LoginMethod.mobilePassword) {
            _params = {
                mobile: params.mobile_number,
                country_code: params.country_code,
                password: params.password,
            };
        }
        else if (loginType === E_LoginMethod.sms) {
            _params = {
                mobile: params.mobile_number,
                country_code: params.country_code,
                verify_code: params.verify_code,
            };
        }
        else if (loginType === E_LoginMethod.wechat) {
            _params = {
                identify_token: params.identify_token,
            };
        }
        else if (loginType === E_LoginMethod.google) {
            _params = {
                google_id_token: params.google_id_token,
            };
        }
        return {
            ..._params,
            login_method_enum: loginType,
        };
    }
    async getTenant(params) {
        const tenants = await postTenantSelectInfosApi(params);
        this.tenants = _.map(tenants, item => {
            if (item.individual) {
                item.tenant_name = this.i18n.t('passport.multiTenant.personalTenant');
            }
            return item;
        });
        return this.tenants;
    }
    /**
     * 默认选中租户
     */
    get DefaultSelectedTenantClose() {
        if (getVar('defaultSelectedTenantClose')) {
            return getVar('defaultSelectedTenantClose') === 'true';
        }
        return false;
    }
    getDefaultTenant(tenants) {
        if (this.DefaultSelectedTenantClose)
            return null;
        if (tenants.length === 1)
            return tenants[0];
        const defaultTenant = _.find(tenants, (tenant) => {
            if (tenant.default_selected) {
                // 上次登录的租户，默认选中，如果不受domain限制、ip限制、sso限制且有权限，则登录默认选中租户，否则让用户自己选择登录
                return !tenant.domain_restrict && !tenant.ip_restrict && !tenant.sso_restrict && tenant.any_privilege_available;
            }
        });
        return defaultTenant;
    }
    close() {
        multiDom.$destroy();
        multiDom.$el.remove();
        multiDom = null;
    }
}
